import React from "react"

function ClueDelivery(props) {

    const classGroup = props.sendClue ? "callout calloutPrinted" : "callout calloutHidden"
    
    return (
        <div className={classGroup} id="clueCallout">
            <h1>{props.clueHeader}</h1>
            <button className="calloutButton" onClick={props.handleClick}>&times;</button>

            <h3 className="calloutText">{props.clue}</h3>
            {!props.cloakroomNudge ? <p className="clueCount">clue {props.clueCount} of {props.totalClues}</p> : undefined}
        </div>
    )
}

export default ClueDelivery